module.exports = __webpack_public_path__ + "media/images/webpage/hotels/93/plan4-2-e9986acae7be297fc51860b452f2ee5e.webp";